import { Text } from '@mantine/core'
import { ReactComponent as Claire } from '../../assets/clair.svg'
import classes from './ClaireCard.module.css'
import { Typography } from '../../common/typography'

export default function ClaireCard({
  title,
  text,
}: {
  title: string
  text: string
}) {
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography fw={500} lh="130">
          {title}
        </Typography>
        <div className={classes.icon_container}>
          <Claire className={classes.icon} />
        </div>
      </div>
      <Text component="p">{text}</Text>
    </div>
  )
}
